<template>
  <div v-loading="detailsLoading" element-loading-text="Loading...">
    <div id="fm_results_head">
      <grid wrap="wrap" :rwd="{numResultSeletorBreaks: 'stack'}">
        <grid-item size="14/24" :rwd="{numResultSeletorBreaks: '24/24'}">
          <div id="fm_results_number_all"> <b>Reviews & Stories: </b>
            <span v-if="showNumTotalResults > 0">{{ showNumTotalResults }} <span style="font-size: 12px; color: #929292;">(Total)</span></span>
            <span v-if="showNumFilteredResults > 0 && showNumTotalResults != showNumFilteredResults"> | {{ showNumFilteredResults }} <span style="font-size: 12px; color: #929292;">(Filtered)</span></span>
            <span v-else style="font-size: 1px">.</span> <!-- Required to make sure num page selector is aligned properly on the right hand side in case there are no counters displayed-->
          </div>
        </grid-item>
        <grid-item size="10/24" :rwd="{numResultSeletorBreaks: '24/24'}">
          <div id="fm_results_per_page" style="text-align: right" >
            <el-radio-group v-model="numResPerPageOptions.selected" size="mini" type="primary" @change="setNumResPerPage(numResPerPageOptions.selected)" v-if="show_results_per_page_selector">
              <el-radio-button v-for="(numOption, indexR) in numResPerPageOptions.options"
                               :label="numOption">
              </el-radio-button>
            </el-radio-group>
            <span style="font-size: 1px" v-else>.</span>
          </div>
        </grid-item>
      </grid>
    </div>

    <div v-if="currentFetchState" style="margin-top: 50px; margin-bottom: 50px; text-align: center">

      <i class="el-icon-loading" style="font-size: 34px;"></i><br />
      Fetching Results NOW
    </div>

    <!-- Start Testimonial Loop -->
    <template v-if="resultColumns == 2">
      <template v-if="!currentFetchState">
        <grid wrap="wrap" vertical="middle" :rwd="{result2Column:'stack'}">
        <grid-item v-for="(testimonial, index) in displayTestimonialResults" size="1/2" :rwd="{result2Column:'1/1'}">
          <div class="result_testimonial_entry_v2">
          <div>
            <el-row :gutter="10">
              <el-col :span="18">
                <div class="result_testimonial_rating">
                  <el-rate
                      v-model="testimonial.fm_stars"
                      disabled
                      show-score
                      text-color="#ff9900"
                      :score-template="modifyStarRatingText(testimonial)">
                  </el-rate>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="result_testimonial_date">{{ testimonial.fm_date }}</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div class="result_testimonial_title">
                  <span style="padding-right: 15px; font-style: italic">{{ index + 1}}.</span> <span v-html="testimonial.fm_title">{{ testimonial.fm_title }}</span>
                </div>

              </el-col>
            </el-row>
          </div>
          <div class="result_testimonial_horizontal_line"></div>
          <!-- Content Preview-->
          <div class="result_testimonial_content_preview" >
            <span v-html="testimonial.fm_content_preview">{{ testimonial.fm_content_preview }}</span>
            <span v-if="testimonial.fm_content_more"> <a href="#" @click.prevent="loadCompleteTestimonialData(testimonial)">... <span style="font-size: 10px;">click for the complete story</span></a></span>
          </div>
          <!-- Footer of Entry -->
          <div class="result_testimonial_footer">
            <el-row>
              <el-col :span="12" style="text-align: left; vertical-align: bottom">
                <span style="font-size: 6px; color: #efefef;">+</span>
              </el-col>
              <el-col :span="12"  style="text-align: right; vertical-align: bottom">
                <el-button type="primary" size="mini" round @click.prevent="loadCompleteTestimonialData(testimonial)" icon="el-icon-zoom-in" ref="">See All Details</el-button>
              </el-col>
            </el-row>
          </div>
          </div>
        </grid-item>
        </grid>
      </template>
    </template>
    <template v-else> <!-- Show one columns only -->
      <template v-if="!currentFetchState">
        <div class="result_testimonial_entry_v2" v-for="(testimonial, index) in displayTestimonialResults">

          <div>
            <el-row :gutter="10">
              <el-col :span="18">
                <div class="result_testimonial_rating">
                  <el-rate
                      v-model="testimonial.fm_stars"
                      disabled
                      show-score
                      text-color="#ff9900"
                      :score-template="modifyStarRatingText(testimonial)">
                  </el-rate>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="result_testimonial_date">{{ testimonial.fm_date }}</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div class="result_testimonial_title">
                  <span style="padding-right: 15px; font-style: italic">{{ index + 1}}.</span> <span v-html="testimonial.fm_title">{{ testimonial.fm_title }}</span>
                </div>

              </el-col>
            </el-row>
          </div>
          <div class="result_testimonial_horizontal_line"></div>
          <!-- Content Preview-->
          <div class="result_testimonial_content_preview" >
            <span v-html="testimonial.fm_content_preview">{{ testimonial.fm_content_preview }}</span>
            <span v-if="testimonial.fm_content_more"> <a href="#" @click.prevent="loadCompleteTestimonialData(testimonial)">... <span style="font-size: 10px;">click for the complete story</span></a></span>
          </div>
          <!-- Footer of Entry -->
          <div class="result_testimonial_footer">
            <el-row>
              <el-col :span="12" style="text-align: left; vertical-align: bottom">
                <span style="font-size: 6px; color: #efefef;">+</span>
              </el-col>
              <el-col :span="12"  style="text-align: right; vertical-align: bottom">
                <el-button type="primary" size="mini" round @click.prevent="loadCompleteTestimonialData(testimonial)" icon="el-icon-zoom-in" ref="">See All Details</el-button>
              </el-col>
            </el-row>
          </div>
        </div>
      </template>
    </template>




    <!-- Testimonial Loop ended -->

    <!-- Load More Button -->
    <fm_load_more_button :moreResultsAvailable="moreResultsAvailable && !noResults" v-if="!currentFetchState"></fm_load_more_button>

    <!-- Notification Boxes -->
    <div class="fm_testimonial_no_results" v-if="noResults && resultsLoaded">
      <el-alert
          title="No Results Matching Filter"
          type="info"
          description="There are no feedback results matching your filters and/or search phrase."
          show-icon>
      </el-alert>
    </div>
    <div class="fm_testimonial_no_yet_triggered" v-if="!resultsLoaded && !currentFetchState">
      <!--<i class="el-icon-loading"></i>-->
      <el-alert
          title="Click The 'Get Results Button' First"
          type="info"
          description="Please click on 'GET Results' to fetch results from the server based on your filter input."
          show-icon>
      </el-alert>
    </div>

    <!-- Placeholder Dialog Box for Details-->
    <fm_result_details_dialog :dialogFormVisible="dialogFormVisible" :resultObject="currentTestimonialDetails" @boxWasClosed="dialogFormVisible = $event"></fm_result_details_dialog>

  </div>
</template>

<script>
  import LoadMoreButton from '../fm_results/ResultLoadMoreButton.vue';
  import ResultDetailsDialogBox from '../fm_results/ResultDetailsDialog';
  import axios from 'axios';

  export default {
    props: ['show_results_per_page_selector', 'resultColumns'],
    components: {
      'fm_load_more_button': LoadMoreButton,
      'fm_result_details_dialog': ResultDetailsDialogBox
    },
    data(){
      return {
        mppData: '',
        moreResultsAvailable: false,
        resultsLoaded: false,
        noResults: false,
        TestimonialDetails: {},
        currentTestimonialDetails: {},
        detailsLoading: false,
        dialogFormVisible: false,
        current_testimonial_id: ''
      }
    },
    methods: {
      modifyStarRatingText(testimonialObject){
        return testimonialObject.fm_stars + ' Star Rating';
      },
      loadCompleteTestimonialData(testimonialObject){
        this.detailsLoading = true;


        //define form data
        let post_data = new FormData();
        post_data.append('action', 'fm_vue_frontend_api_fetch_details');
        post_data.append('fm_testimonial_id', testimonialObject.fm_id);

        //add search phrase as well.
        const searchPhrase = this.$store.getters.getMPPSearchPhrase;
        if(typeof searchPhrase == "string" && searchPhrase !== ''){
          post_data.append('search_phrase', searchPhrase);
        }

        //contact server
        axios.post('?action=fm_vue_frontend_api_fetch_details', post_data)
             .then(response => {
               if(response.data.info.status){
                 //add results to global store
                 this.$store.dispatch('addMPPTestimonialDetails', response.data);
                 //add to local variable
                 this.TestimonialDetails[testimonialObject.fm_id] = response.data.data;
                 this.currentTestimonialDetails = response.data.data;

                 //show dialog box
                 this.dialogFormVisible = true;
                 this.detailsLoading = false;
               }
             })
             .catch(error => {
               console.log(error);
             })
      },
      setNumResPerPage(selectedOption){
        this.$store.dispatch('setMPPNumResPerPageSelected',selectedOption);
        this.detailsLoading = true;
        this.$store.dispatch('globalActionMPPFetchResults', {someData:{ setToPageOne: true}})
            .then(response => {
              this.detailsLoading = false;
            });
      }
    },
    computed: {
      showLoadingHTMLContent(){
        return "<i class='el-icon-loading'></i> Loading results.";
      },
      currentFetchState(){
        return this.$store.getters.getMPPFetchingResultsNow;
      },
      showGeneralResult() {
        this.mppData = this.$store.getters.getGeneralResponse;
      },
      showNumTotalResults(){
        return this.$store.getters.getMPPTotalResultsNum;
      },
      showNumFilteredResults(){
        return this.$store.getters.getMPPFilteredResultsNum;
      },
      displayTestimonialResults() {
        let mppResults = [];
        mppResults     = this.$store.getters.getMPPResults;

        if (mppResults.length > 0) {
          this.moreResultsAvailable = true;
          this.noResults            = false;
          this.resultsLoaded        = true;
        } else {
          this.noResults = true;
        }

        return mppResults;
      },
      numResPerPageOptions: {
        get() {
          //console.log(this.$store.getters.getMPPResultsPerPageObject);
          return this.$store.getters.getMPPResultsPerPageObject;
        },
        set(selectedOption) {
          /*see called function via change ... set not working with element ui*/
        }
      }
    },
    watch: {
      numResPerPageOptions: function(changedValue){
        console.log('changed number' + changedValue);
      }
    },
    beforeCreate(){ //not doing what intented.
      //decide about bar to show based on submitted wpData object

    }
  }
</script>

<style scoped lang="scss">
  div.result_testimonial_entry {
    border: dashed #a8a8a8 1px;
    padding: 10px;
    border-radius: 7px;
    margin-bottom: 10px;
  }

  div.result_testimonial_entry_v2 {
    border: solid #EBEEF5 1px;
    padding: 10px;
    border-radius: 7px;
    margin-bottom: 10px;

    -webkit-box-shadow: 0px 0px 4px 0px rgba(227,224,227,1);
    -moz-box-shadow: 0px 0px 4px 0px rgba(227,224,227,1);
    box-shadow: 0px 0px 4px 0px rgba(227,224,227,1);
  }

  div#fm_results_head {
    margin-bottom: 10px;
  }

  div.result_testimonial_title {
    font-weight: bold;
    margin-top: 15px;
    /*white-space: pre; Execute rather than show HTML of text*/
  }

  div.result_testimonial_date {
    font-style: italic;
    font-size: 12px;
    text-align: right;
  }

  div.result_testimonial_footer {
    margin-top: 15px;
  }

  div.result_testimonial_horizontal_line {
    height: 2px;
    border-bottom: solid 1px #e7e7e7;
    margin-bottom: 10px;
    margin-top: 5px;
  }
</style>

<style lang="scss">
  span.search_hint {
    background-color: #ffc72d;
  }
</style>